import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

/**
 * Restricts access to Super Admin (role_id === 1) only.
 */
const SuperAdminRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  if (Number(user?.role_id) !== 1) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default SuperAdminRoute;
